import { Component, OnInit } from '@angular/core'
import { UntypedFormBuilder } from '@angular/forms'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/core/core.state'
import { NotificationService } from 'src/app/core/notification.service'
import { ConfigurationOptionService } from '../configuration-option.service'
import { UntilDestroy } from '@ngneat/until-destroy'
import { configurationOptionSelectors } from '../configuration-option.selectors'
import { ConfigurationOptionMemberFormConfigTabBase } from '../member-form-config-tab.base'
import { take } from 'rxjs/operators'
import { ConfigurationOptionKeys } from '../configuration-option'

@UntilDestroy()
@Component({
  selector: 'configuration-option-registration-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionRegistrationTabComponent
  extends ConfigurationOptionMemberFormConfigTabBase
  implements OnInit
{
  constructor(
    store: Store<AppState>,
    fb: UntypedFormBuilder,
    notificationService: NotificationService,
    actions$: Actions,
    configOptionService: ConfigurationOptionService
  ) {
    super(store, fb, notificationService, actions$, configOptionService)
  }

  ngOnInit() {
    this.initializeMemberFormConfigEditor(
      this.store.select(
        configurationOptionSelectors.selectByKey,
        ConfigurationOptionKeys.MEMBER_REGISTRATION_FORM_CONFIG
      ),
      true
    )
  }

  public onSubmitRegistration(form): void {
    this.configOption$.pipe(take(1)).subscribe((configOption) => {
      const configOptionValue = this.buildSerializedConfigOptionValue(
        form.value
      )
      const memberURLExplanations = this.getMemberCategoryUrlValues(form.value)

      this.dispatchCreateOrUpdateConfigOption({
        configOption,
        key: ConfigurationOptionKeys.MEMBER_REGISTRATION_FORM_CONFIG,
        value: configOptionValue
      })
      this.configOptionService.updateOrCreateMany(memberURLExplanations)
    })

    this.notifyOnSuccessfulUpsert()
  }

  public onSubmitMemberCategoryUrls(form): void {
    this.configOptionService.updateOrCreateMany(
      this.getMemberCategoryUrlValues(form.value)
    )

    this.notificationService.emit('alerts.success', 'success')
  }
}
